export const adminNavItems = [
  { section: "users", label: "users", path: "/admin/users" },
  { section: "config", label: "config", path: "/admin/config" },
  { section: "flags", label: "flags", path: "/admin/flags" },
  { section: "usage", label: "usage", path: "/admin/usage" },
  { section: "recordings", label: "recordings", path: "/admin/recordings" },
  { section: "sql", label: "sql", path: "/admin/sql" },
] as const;

export type AdminSection = (typeof adminNavItems)[number]["section"];

export const adminUsersPath = adminNavItems[0].path;
export const adminSpaPaths = ["/admin", ...adminNavItems.map((item) => item.path)] as const;

export function isAdminPath(pathname: string): boolean {
  return (adminSpaPaths as readonly string[]).includes(pathname);
}

export function adminSectionFromPath(pathname: string): AdminSection {
  return adminNavItems.find((item) => item.path === pathname)?.section ?? "users";
}
